export const onTabButtonTapped = (
  product: string,
  platform: string,
  index: number,
) => ({
  type: product,
  object_name: 'sideNavTab',
  index_position: index,
  index_count: index,
  object: 'Button',
  action: 'Tapped',
  event_description: 'Tab Selected',
  call_type: 'track',
  feature: 'Side Nav',
  platform: platform,
})

export const onTabButtonSettingsTapped = (
  product: string,
  platform: string,
) => ({
  type: product,
  object_name: 'sideNavTab',
  object: 'Button',
  action: 'Tapped',
  event_description: 'Tab Selected',
  call_type: 'track',
  feature: 'Side Nav',
  platform: platform,
  destination: 'menu',
})

export const onBottomNavButtonTapped = (product: string, index: number) => ({
  object_name: 'bottomNavTab',
  type: product,
  index_position: index,
  index_count: index,
  event_description: 'Tab Selected',
  call_type: 'track',
  feature: 'Bottom Nav',
  platform: 'mobile',
})

export const onLearnTipNextTapped = (
  title: string,
  body: string,
  index: number,
  numberOfTips: number,
) => ({
  object_name: 'learnTip',
  screen: 'present',
  screen_name: 'present',
  title: title,
  body: body,
  index_position: index,
  cta_title: `${index}/${numberOfTips}`,
})

export const onLearnTipCancelTapped = (
  title: string,
  body: string,
  index: number,
) => ({
  object_name: 'learnTip',
  screen: 'present',
  screen_name: 'present',
  title: title,
  body: body,
  index_position: index,
})
